import React, {useContext} from "react";
import {styled} from '@mui/system';
import Tooltip from "@mui/material/Tooltip";
import {Icon, tooltipClasses} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {LanguageContext} from "../../context/LanguageContext";
import {UserContext} from "../../context/UserContext";
import {getUserFullName} from "../../utils/commonFunctions";
import {CustomerContext} from "../../context/CustomerContext";

const TooltipStyled = styled(({className, ...props}) => (
  // speciális eset https://mui.com/material-ui/react-tooltip/#customization
  (<Tooltip {...props} classes={{popper: className}}/>)))(({theme}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: theme.palette.primary.dark,
    maxWidth: 480,
    height: "auto",
    width: 220,
    border: `1px solid ${theme.palette.primary.pale}`,
  }
}));

const TooltipRow = ({title, value}) => (
  <Grid item xs={12}>
    <Typography variant="subtitle2" sx={{textAlign: "center", fontSize: 16, color: "secondary.main"}}>
      {title}:
    </Typography>
    <Typography variant="subtitle1" sx={{textAlign: "center", fontSize: 15, color: "primary.main"}}>
      {value}
    </Typography>
  </Grid>
);

const ProfileButtonTooltip = ({...props}) => {
  const userContext = useContext(UserContext);
  const languageContext = useContext(LanguageContext);
  const customerContext = useContext(CustomerContext);

  return (
    <TooltipStyled
      {...props}
      enterDelay={1000}
      title={(
        <Grid container direction="column" justifyContent="center" alignItems="center" rowSpacing={1} padding={1}>
          <Grid>
            <Icon style={{fontSize: 40}} sx={{color: "secondary.main"}}>{"account_circle_outlined"}</Icon>
          </Grid>
          <Grid container>
            <TooltipRow
              key={"name"}
              title={languageContext.dictionary.name}
              value={getUserFullName(userContext.userInfo, customerContext.selectedContact, languageContext.language.id)}
            />
            <TooltipRow
              key={"companyName"}
              title={languageContext.dictionary.companyName}
              value={customerContext?.selectedCustomer?.name || ""}
            />
            <TooltipRow
              key={"email"}
              title={languageContext.dictionary.email}
              value={customerContext?.selectedContact?.email?.toLowerCase() || userContext.userInfo.email}
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default ProfileButtonTooltip;
